import {validateAadhaarNumber, validatePANNumber} from "@qoohoo/common/utils/validators";

// TODO: webhook URL should be different than the production webhook url
export const entity_or_creator = {
  title: 'Fill the details',
  api: {
    user_form: {
      url: 'https://hook.us1.make.com/qm8uuty19819vvadub0qbmsqgowtdh5y',
      method: 'POST',
      preparePayload: (formData, userData, channelDetails) => ({
        aadhaar_number: formData.aadhaar_number,
        pan_number: formData.pan_number,
        channel_name: channelDetails.name,
        channel_id: channelDetails.uid,
        username: userData.name || userData.username,
        mobile: userData.mobile,
        payment_status: false,
      })
    },
    update_on_payment: {
      url: 'https://hook.us1.make.com/c6orhhbze7kk3o2qpd647w3c9cyjobv2',
      method: 'POST',
      preparePayload: (userData, channelDetails) => ({
        channel_id: channelDetails.uid,
        mobile: userData.mobile,
        payment_status: true,
      })
    }
  },

  order: [
    'aadhaar_number',
    'pan_number'
  ],
  fields: {
    aadhaar_number: {
      name: 'aadhaar_number',
      type: 'text',
      required: true,
      label: 'Aadhaar number',
      placeholder: 'Aadhaar number',
      validator: validateAadhaarNumber,
      formatValue: (val) => val.toUpperCase().trim()
    },
    pan_number: {
      name: 'pan_number',
      type: 'text',
      required: true,
      label: 'PAN number',
      placeholder: 'PAN number',
      validator: validatePANNumber,
      formatValue: (val) => val.toUpperCase().trim()

    },
  },
};